import React, {ReactElement, useMemo} from 'react';
import CalendrierCell from "./calendrier-cell";
import IUnite from "../../models/IUnite";
import {add, format, sub} from "date-fns";
import {useCalendrierProps} from "./calendrier";
import {TypeCalendrier} from './calendrier-interfaces';

function isToday(date: Date, byMonth: Boolean, today = new Date()) {
    const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()); // Date only, no time
    const inputDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()); // Date only, no time
    if (byMonth)
        return today.getMonth() === date.getMonth() && today.getFullYear() === date.getFullYear();
    return todayDate.getTime() === inputDate.getTime();
}

function isWeekend(date: Date) {
    const day = date.getDay();
    return day === 0 || day === 6;
}

interface ICalendrierGridRowProps {
    unite: IUnite,
    isSelected?: Boolean,
    ligne?: number
}

const CalendrierGridRowCells = ({unite, isSelected, ligne}: ICalendrierGridRowProps) => {
    const {dateCourrante, nbColonne, typeCalendrier, calendrierData, selectedTypeUnite} = useCalendrierProps();
    const reservation = (calendrierData || []).filter(f => f.idUnite.equals(unite.idUnite));

    const renderColonne = useMemo(() => {
        // const arr = new Array(nbColonne).fill({}).map((_, i) => {
        if (!selectedTypeUnite?.calDateDebut) {
            return new Array(nbColonne).fill({}).map((_, i) => {
                const date = add(dateCourrante, {[typeCalendrier === TypeCalendrier.Jours ? "days" : "months"]: i});
                return <CalendrierCell key={`cell-${unite.idUnite}-${i + 2}`}
                                       idUnite={unite.idUnite}
                                       date={date}
                                       cell-date={`${unite.idUnite}|${format(date, typeCalendrier === TypeCalendrier.Jours ? "yyyyMMdd" : "yyyyMM")}`}
                                       style={{gridColumn: 3 + i}}
                                       ligne={ligne}
                                       colonne={i}
                                       isWeekend={typeCalendrier === TypeCalendrier.Jours ? isWeekend(date) : false}
                                       isToday={isToday(date, typeCalendrier !== TypeCalendrier.Jours)}
                />
            });
        }
        const arr: ReactElement[] = [];
        let duree = 1;

        function checkSiDuree(object: ReactElement) {
            if (selectedTypeUnite && selectedTypeUnite?.dureePeriode !== 1) {
                if (duree == selectedTypeUnite.dureePeriode)
                    duree = 1;
                else {
                    arr.push(object);
                    duree++;
                }
            } else
                arr.push(object);
        }

        if (dateCourrante && nbColonne && typeCalendrier
            && selectedTypeUnite && selectedTypeUnite?.calDateDebut
            && selectedTypeUnite?.calDateFin &&
            selectedTypeUnite?.calDateDebut instanceof Date &&
            selectedTypeUnite?.calDateFin instanceof Date) {

            const calDateDebut = new Date(dateCourrante.getFullYear(), selectedTypeUnite.calDateDebut.getMonth(), selectedTypeUnite.calDateDebut.getDate())
            const calDateFin = new Date(dateCourrante.getFullYear(), selectedTypeUnite.calDateFin.getMonth(), selectedTypeUnite.calDateFin.getDate())
            if (calDateFin < calDateDebut) {
                calDateDebut.setFullYear(calDateDebut.getFullYear() - 1);
            }
            let dateDebut = dateCourrante;

            if (typeCalendrier === TypeCalendrier.Jours) {
                dateDebut.setHours(0)
                dateDebut.setMinutes(0);
                dateDebut.setSeconds(0);
                dateDebut.setMilliseconds(0);
            }

            for (let i = 0; arr.length < nbColonne; i++) {

                let date = add(dateDebut, {[typeCalendrier === TypeCalendrier.Jours ? "days" : "months"]: i});

                const object = <CalendrierCell key={`cell-${unite.idUnite}-${i + 2}`}
                                               idUnite={unite.idUnite}
                                               date={date}
                                               cell-date={`${unite.idUnite}|${format(date, typeCalendrier === Number(TypeCalendrier.Jours) ? "yyyyMMdd" : "yyyyMM")}`}
                                               style={{gridColumn: 3 + arr.length}}
                                               ligne={ligne}
                                               colonne={arr.length}
                                               isWeekend={
                                                   typeCalendrier === Number(TypeCalendrier.Jours)
                                                       ? isWeekend(date)
                                                       : false
                                               }
                                               isToday={
                                                   isToday(date, typeCalendrier !== Number(TypeCalendrier.Jours)
                                                   )}
                />
                if (typeCalendrier === TypeCalendrier.Mois) {
                    if (!selectedTypeUnite?.calDateDebut) {
                        arr.push(object);
                    } else if (
                        (date.getMonth() >= selectedTypeUnite.calDateDebut.getMonth() && date.getMonth() <= selectedTypeUnite.calDateFin.getMonth()) ||
                        (selectedTypeUnite.calDateFin < selectedTypeUnite.calDateDebut && (date.getMonth() <= selectedTypeUnite.calDateDebut.getMonth() ||
                            date.getMonth() >= selectedTypeUnite.calDateFin.getMonth()))
                    ) checkSiDuree(object);
                } else if (typeCalendrier === TypeCalendrier.Jours) {
                    if (date >= calDateDebut && date <= calDateFin) {
                        checkSiDuree(object);
                    }
                } else
                    arr.push(object);

                if (date >= calDateFin) {
                    calDateDebut.setFullYear(calDateDebut.getFullYear() + 1);
                    calDateFin.setFullYear(calDateFin.getFullYear() + 1);
                    dateDebut = sub(calDateDebut, {[typeCalendrier === TypeCalendrier.Jours ? "days" : "months"]: i + 1})
                }
            }
        }
        return arr
    }, [nbColonne, dateCourrante, typeCalendrier, unite.idUnite, ligne, selectedTypeUnite]);

    return useMemo(() => <>
        <CalendrierCell
            key={`cell-unite-${unite.idUnite}-1`}
            className={`unite ${isSelected && "selected"}`}>
            {unite.description}
        </CalendrierCell>
        <CalendrierCell
            key={`cell-personne-${unite.idUnite}-2`}
            className="nbpersonne">
            {`${unite.nombrePersonne}`}
        </CalendrierCell>
        {renderColonne}
    </>, [unite.idUnite, isSelected, unite.description, unite.nombreAdultesMaximum, unite.nombreEnfantsMaximum, renderColonne]);
}

export default CalendrierGridRowCells;